
export const COMPANY_INFO = {
  name: 'Balam Technology',
  tagline: 'Custom software, built with trust.',
  hero: {
    title: 'We build the future with custom software.',
    subtitle: 'Innovation, trust, modern tech.',
    cta: 'Contact Us'
  },
  services: [
    {
      title: 'Website Development',
      description: 'Modern UI with responsive design and optimized performance.',
      benefits: 'Fast, SEO-friendly, mobile-first approach'
    },
    {
      title: 'Landing Pages',
      description: 'High-converting pages that drive results for your business.',
      benefits: 'Conversion-optimized, A/B tested, analytics-ready'
    },
    {
      title: 'Web Applications',
      description: 'Scalable web apps with modern architecture and UX.',
      benefits: 'Scalable backends, secure architecture, cloud-ready'
    },
    {
      title: 'API Development',
      description: 'Secure APIs with robust documentation and monitoring.',
      benefits: 'RESTful design, secure endpoints, comprehensive docs'
    }
  ],
  techStack: [
    { name: 'AWS', description: 'Cloud infrastructure and services' },
    { name: 'React', description: 'Modern frontend framework' },
    { name: 'TailwindCSS', description: 'Utility-first CSS framework' },
    { name: 'Serverless', description: 'Scalable serverless architecture' },
    { name: 'Monolithic', description: 'When architecture demands it' }
  ],
  about: {
    title: 'A young company with senior standards.',
    description: 'We are passionate about delivering quality software solutions. Our workflow: discovery → design → develop → deploy.',
    workflow: ['Discovery', 'Design', 'Develop', 'Deploy']
  },
  contact: {
    title: 'Tell us about your project',
    description: 'Ready to bring your ideas to life? Let\'s discuss your project requirements.'
  }
};

export const NAVIGATION_LINKS = [
  { name: 'Home', href: '#home' },
  { name: 'Services', href: '#services' },
  { name: 'Tech Stack', href: '#tech-stack' },
  { name: 'About', href: '#about' },
  { name: 'Contact', href: '#contact' }
];

export const SOCIAL_LINKS = [
  { name: 'LinkedIn', href: '#', icon: 'ri-linkedin-fill' },
  { name: 'GitHub', href: '#', icon: 'ri-github-fill' },
  { name: 'Twitter', href: '#', icon: 'ri-twitter-fill' }
];
